// extracted by mini-css-extract-plugin
export default {"container":"id-title_container__rfvqK"};